// Configuração de GIFs personalizados para BelottoPokeClass Center
// Você pode substituir estes URLs pelos seus próprios GIFs

export const monsterGifs = {
  // 15 GIFs para classe TANK
  tank: [
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/1.gif',   // Bulbasaur
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/7.gif',   // Squirtle
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/27.gif',  // Sandshrew
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/95.gif',  // Onix
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/143.gif', // Snorlax
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/111.gif', // Rhyhorn
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/104.gif', // Cubone
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/185.gif', // Sudowoodo
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/208.gif', // Steelix
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/213.gif', // Shuckle
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/246.gif', // Larvitar
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/299.gif', // Nosepass
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/304.gif', // Aron
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/377.gif', // Regirock
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/410.gif'  // Shieldon
  ],
  
  // 15 GIFs para classe WARRIOR (Guerreiro)
  warrior: [
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/4.gif',   // Charmander
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/56.gif',  // Mankey
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/66.gif',  // Machop
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/68.gif',  // Machamp
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/107.gif', // Hitmonchan
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/106.gif', // Hitmonlee
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/126.gif', // Magmar
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/156.gif', // Quilava
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/214.gif', // Heracross
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/236.gif', // Tyrogue
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/237.gif', // Hitmontop
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/255.gif', // Torchic
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/286.gif', // Breloom
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/308.gif', // Medicham
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/392.gif'  // Infernape
  ],
  
  // 15 GIFs para classe SUPPORT (Suporte)
  support: [
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/25.gif',  // Pikachu
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/35.gif',  // Clefairy
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/39.gif',  // Jigglypuff
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/113.gif', // Chansey
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/122.gif', // Mr. Mime
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/175.gif', // Togepi
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/183.gif', // Marill
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/242.gif', // Blissey
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/280.gif', // Ralts
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/300.gif', // Skitty
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/303.gif', // Mawile
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/311.gif', // Plusle
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/312.gif', // Minun
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/385.gif', // Jirachi
    'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/versions/generation-v/black-white/animated/440.gif'  // Happiny
  ]
};

// GIF do ovo - você pode substituir por qualquer GIF de ovo que preferir
export const eggGif = 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/items/lucky-egg.png';

// Função para obter um GIF aleatório de uma classe
export const getRandomMonsterGif = (classType) => {
  const gifs = monsterGifs[classType] || monsterGifs.tank;
  const randomIndex = Math.floor(Math.random() * gifs.length);
  return {
    gif: gifs[randomIndex],
    index: randomIndex
  };
};

// Nomes dos monstros por classe (você pode personalizar)
export const monsterNames = {
  tank: [
    'Bulbasaur', 'Squirtle', 'Sandshrew', 'Onix', 'Snorlax',
    'Rhyhorn', 'Cubone', 'Sudowoodo', 'Steelix', 'Shuckle',
    'Larvitar', 'Nosepass', 'Aron', 'Regirock', 'Shieldon'
  ],
  warrior: [
    'Charmander', 'Mankey', 'Machop', 'Machamp', 'Hitmonchan',
    'Hitmonlee', 'Magmar', 'Quilava', 'Heracross', 'Tyrogue',
    'Hitmontop', 'Torchic', 'Breloom', 'Medicham', 'Infernape'
  ],
  support: [
    'Pikachu', 'Clefairy', 'Jigglypuff', 'Chansey', 'Mr. Mime',
    'Togepi', 'Marill', 'Blissey', 'Ralts', 'Skitty',
    'Mawile', 'Plusle', 'Minun', 'Jirachi', 'Happiny'
  ]
};

// Evolução por estágio. Cada índice mapeia para os 3 estágios.
// Para monstros que não têm evolução biológica, todos os estágios mantêm o mesmo nome.
// Stage 1 = base | Stage 2 = primeira evolução | Stage 3 = evolução final.
export const monsterEvolutionNames = {
  tank: {
    0:  { stage_1: 'Bulbasaur',  stage_2: 'Ivysaur',   stage_3: 'Venusaur'   },
    1:  { stage_1: 'Squirtle',   stage_2: 'Wartortle', stage_3: 'Blastoise'  },
    2:  { stage_1: 'Sandshrew',  stage_2: 'Sandslash', stage_3: 'Sandslash'  },
    3:  { stage_1: 'Onix',       stage_2: 'Steelix',   stage_3: 'Steelix'    },
    4:  { stage_1: 'Munchlax',   stage_2: 'Snorlax',   stage_3: 'Snorlax'    },
    5:  { stage_1: 'Rhyhorn',    stage_2: 'Rhydon',    stage_3: 'Rhyperior'  },
    6:  { stage_1: 'Cubone',     stage_2: 'Marowak',   stage_3: 'Marowak'    },
    7:  { stage_1: 'Bonsly',     stage_2: 'Sudowoodo', stage_3: 'Sudowoodo'  },
    8:  { stage_1: 'Onix',       stage_2: 'Steelix',   stage_3: 'Steelix'    },
    9:  { stage_1: 'Shuckle',    stage_2: 'Shuckle',   stage_3: 'Shuckle'    },
    10: { stage_1: 'Larvitar',   stage_2: 'Pupitar',   stage_3: 'Tyranitar'  },
    11: { stage_1: 'Nosepass',   stage_2: 'Probopass', stage_3: 'Probopass'  },
    12: { stage_1: 'Aron',       stage_2: 'Lairon',    stage_3: 'Aggron'     },
    13: { stage_1: 'Regirock',   stage_2: 'Regirock',  stage_3: 'Regirock'   },
    14: { stage_1: 'Shieldon',   stage_2: 'Bastiodon', stage_3: 'Bastiodon'  },
  },
  warrior: {
    0:  { stage_1: 'Charmander', stage_2: 'Charmeleon', stage_3: 'Charizard'  },
    1:  { stage_1: 'Mankey',     stage_2: 'Primeape',   stage_3: 'Primeape'   },
    2:  { stage_1: 'Machop',     stage_2: 'Machoke',    stage_3: 'Machamp'    },
    3:  { stage_1: 'Machop',     stage_2: 'Machoke',    stage_3: 'Machamp'    },
    4:  { stage_1: 'Tyrogue',    stage_2: 'Hitmonchan', stage_3: 'Hitmonchan' },
    5:  { stage_1: 'Tyrogue',    stage_2: 'Hitmonlee',  stage_3: 'Hitmonlee'  },
    6:  { stage_1: 'Magby',      stage_2: 'Magmar',     stage_3: 'Magmortar'  },
    7:  { stage_1: 'Cyndaquil',  stage_2: 'Quilava',    stage_3: 'Typhlosion' },
    8:  { stage_1: 'Heracross',  stage_2: 'Heracross',  stage_3: 'Heracross'  },
    9:  { stage_1: 'Tyrogue',    stage_2: 'Hitmonchan', stage_3: 'Hitmonchan' },
    10: { stage_1: 'Tyrogue',    stage_2: 'Hitmontop',  stage_3: 'Hitmontop'  },
    11: { stage_1: 'Torchic',    stage_2: 'Combusken',  stage_3: 'Blaziken'   },
    12: { stage_1: 'Shroomish',  stage_2: 'Breloom',    stage_3: 'Breloom'    },
    13: { stage_1: 'Meditite',   stage_2: 'Medicham',   stage_3: 'Medicham'   },
    14: { stage_1: 'Chimchar',   stage_2: 'Monferno',   stage_3: 'Infernape'  },
  },
  support: {
    0:  { stage_1: 'Pichu',      stage_2: 'Pikachu',    stage_3: 'Raichu'     },
    1:  { stage_1: 'Cleffa',     stage_2: 'Clefairy',   stage_3: 'Clefable'   },
    2:  { stage_1: 'Igglybuff',  stage_2: 'Jigglypuff', stage_3: 'Wigglytuff' },
    3:  { stage_1: 'Happiny',    stage_2: 'Chansey',    stage_3: 'Blissey'    },
    4:  { stage_1: 'Mime Jr.',   stage_2: 'Mr. Mime',   stage_3: 'Mr. Mime'   },
    5:  { stage_1: 'Togepi',     stage_2: 'Togetic',    stage_3: 'Togekiss'   },
    6:  { stage_1: 'Azurill',    stage_2: 'Marill',     stage_3: 'Azumarill'  },
    7:  { stage_1: 'Happiny',    stage_2: 'Chansey',    stage_3: 'Blissey'    },
    8:  { stage_1: 'Ralts',      stage_2: 'Kirlia',     stage_3: 'Gardevoir'  },
    9:  { stage_1: 'Skitty',     stage_2: 'Delcatty',   stage_3: 'Delcatty'   },
    10: { stage_1: 'Mawile',     stage_2: 'Mawile',     stage_3: 'Mawile'     },
    11: { stage_1: 'Plusle',     stage_2: 'Plusle',     stage_3: 'Plusle'     },
    12: { stage_1: 'Minun',      stage_2: 'Minun',      stage_3: 'Minun'      },
    13: { stage_1: 'Jirachi',    stage_2: 'Jirachi',    stage_3: 'Jirachi'    },
    14: { stage_1: 'Happiny',    stage_2: 'Chansey',    stage_3: 'Blissey'    },
  }
};

// Função para obter nome do monstro (com suporte a estágio de evolução)
export const getMonsterName = (classType, index, stage = 1) => {
  const evolutions = monsterEvolutionNames[classType];
  if (evolutions && evolutions[index]) {
    const stageKey = `stage_${stage}`;
    if (evolutions[index][stageKey]) {
      return evolutions[index][stageKey];
    }
    // Fallback: maior estágio definido <= stage solicitado
    for (let s = stage; s >= 1; s -= 1) {
      if (evolutions[index][`stage_${s}`]) return evolutions[index][`stage_${s}`];
    }
  }
  // Fallback final: tabela legada (sem evolução)
  const names = monsterNames[classType] || monsterNames.tank;
  return names[index] || `Monstro #${index}`;
};
